export default "__VITE_ASSET__f47ec208__"